import React from "react";
import ReactDOM from "react-dom/client";
import "./css/index.css";
import App from "./App";
import store, { persistor } from "./redux/store";
import MobileDetector from "./components/MobileDetector";
import { Provider } from "react-redux";
import Modal from "react-modal";
import { PersistGate } from "redux-persist/integration/react";

Modal.setAppElement("#root");

const root = ReactDOM.createRoot(document.getElementById("root"));
// Suppress specific warnings in development
if (process.env.NODE_ENV === "development") {
  const suppressedWarnings = [
    /Function components cannot be given refs/,
    /Unexpected return value from a callback ref/,
  ];

  const originalWarn = console.warn;
  const originalError = console.error;

  console.warn = (...args) => {
    if (suppressedWarnings.some((pattern) => pattern.test(args[0]))) {
      return;
    }
    originalWarn(...args);
  };

  console.error = (...args) => {
    if (suppressedWarnings.some((pattern) => pattern.test(args[0]))) {
      return;
    }
    originalError(...args);
  };
}

root.render(
  <Provider store={store}>
    <PersistGate loading={null} persistor={persistor}>
      <React.StrictMode>
        <MobileDetector />
        <App />
      </React.StrictMode>
    </PersistGate>
  </Provider>
);
